<template>
  <fixed-header
    :threshold="fixedHeaderThreshhold"
    header-class="site-header"
    fixed-class="site-header--fixed"
  >
    <header
      id="site-header"
    >
      <div class="header">
        <div class="container">
          <nav class="navbar">
            <div class="container-fluid">
              <div class="navbar-header">
                <button
                  :aria-label="resourceStrings.NavbarToggle"
                  type="button"
                  class="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#navbar"
                  aria-expanded="false"
                  aria-controls="navbar"
                >
                  <i
                    class="fa fa-fw fa-bars opener"
                    aria-hidden="true"
                  />
                </button>
                <a
                  :href="cartIndexUrl"
                  :aria-label="resourceStrings.Cart"
                  class="header__cart-nav-item visible-xs"
                  @click="handleCartLinkClick"
                >
                  <img
                    :src="cartSvg"
                    :alt="resourceStrings.Cart"
                    style="z-index: 99999;"
                    width="25"
                  >
                  <div
                    v-show="numItemsInCart > 0"
                    class="header__bubble-container"
                  >
                    <span class="header__navigation-bubble">{{ numItemsInCart }}</span>
                  </div>
                </a>
                <a
                  :href="homeIndexUrl"
                  :aria-label="resourceStrings.GradImagesLogo"
                  :title="resourceStrings.GradImagesLogo"
                  class="header__logo-wrapper"
                >
                  <img
                    :src="gradLogoSvg"
                    :alt="resourceStrings.GradImagesLogo"
                    class="header__logo-img"
                  >
                </a>
              </div>
              <div
                id="navbar"
                class="navbar-collapse collapse"
              >
                <ul class="nav navbar-nav navbar-right header-navbar__nav">
                  <li
                    v-if="customerPin"
                    class="header__navigation-item"
                  >
                    <a :href="homeIndexUrl">{{ resourceStrings.LinkHome }}</a>
                  </li>
                  <li
                    v-if="customerPin && showBalfourOffers"
                    class="header__navigation-item"
                  >
                    <a
                      :href="specialOffersUrl"
                      aria-label="Special Offers"
                      @click="handleSpecialOffersLinkClick"
                    >Special Offers</a>
                  </li>
                  <li
                    v-if="customerPin && !occasionStatusIsPreEvent"
                    :class="proofsLinkNavItemClasses"
                  >
                    <a :href="proofsIndexUrl">
                      {{ resourceStrings.LinkView }}
                      <span class="hidden-sm">{{ resourceStrings.LinkMy }}</span>
                      {{ resourceStrings.LinkPhotos }}
                    </a>
                  </li>
                  <li
                    v-if="occasionStatusIsPreEvent && catalogListUrl"
                    class="header__navigation-item"
                  >
                    <a :href="catalogListUrl">Pre-Order Photos</a>
                  </li>
                  <li
                    v-if="customerPin"
                    :class="packageListNavItemClasses"
                  >
                    <a :href="catalogListUrl">{{ resourceStrings.ViewPackages }}</a>
                  </li>
                  <li
                    v-if="!customerPin"
                    class="header__navigation-item header__navigation-item--fmp"
                  >
                    <a :href="homeSearchUrl">
                      {{ resourceStrings.LinkFind }}
                      <span class="hidden-sm">{{ resourceStrings.LinkMy }}</span>
                      {{ resourceStrings.LinkPhotos }}
                    </a>
                  </li>
                  <li
                    v-if="!customerPin && showBalfourOffers"
                    class="header__navigation-item"
                  >
                    <a
                      :href="specialOffersUrl"
                      aria-label="Special Offers"
                      @click="handleSpecialOffersLinkClick"
                    >Special Offers</a>
                  </li>
                  <li
                    v-if="!customerPin"
                    class="header__navigation-item"
                  ><a
                    :href="preregistrationUrl"
                    aria-label="Pre-Event Registration"
                  >{{ resourceStrings.LinkRegistration }}</a>
                  </li>
                  <li class="dropdown header__navigation-item">
                    <a
                      href="#"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ selectedLanguage }}
                      <span class="caret" />
                    </a>
                    <ul
                      class="dropdown-menu"
                    >
                      <li
                        v-for="(languageLink, index) in languageLinks"
                        :key="index"
                      >
                        <a
                          :href="languageLink.url"
                          @click="handleLanguageNavClick(languageLink.code)"
                        >{{ languageLink.label }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="dropdown header__navigation-item">
                    <a
                      href="#"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <img
                        :src="helpSvg"
                        :alt="resourceStrings.Chat"
                        width="25"
                      >
                    </a>
                    <ul class="dropdown-menu">
                      <li>
                        <a :href="contactUsUrl">{{ resourceStrings.LinkContactUs }}</a>
                      </li>
                      <li>
                        <a
                          href="#"
                          @click.prevent="openChatWindow"
                        >{{ resourceStrings.LinkLiveChat }}</a>
                      </li>
                      <li>
                        <a :href="emailUsUrl">{{ resourceStrings.LinkQuestionsComments }}</a>
                      </li>
                      <li>
                        <a :href="faqUrl">{{ resourceStrings.LinkFAQ }}</a>
                      </li>
                      <li>
                        <a :href="trackUrl">{{ resourceStrings.LinkTrackOrders }}</a>
                      </li>
                    </ul>
                  </li>
                  <li class="header__navigation-item header__icon-container hidden-xs">
                    <a
                      :href="cartIndexUrl"
                      :aria-label="resourceStrings.Cart"
                      @click="handleCartLinkClick"
                    >
                      <img
                        :src="cartSvg"
                        :alt="resourceStrings.Cart"
                        style="z-index: 99999;"
                        width="25"
                      >
                      <div
                        v-show="numItemsInCart > 0"
                        class="header__bubble-container"
                      >
                        <span class="header__navigation-bubble">{{ numItemsInCart }}</span>
                      </div>
                    </a>
                    <div
                      v-show="showCartBadge"
                      class="header__cart-badge"
                    >
                      <div class="header__cart-badge-text">{{ resourceStrings.AddedToCart }}</div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  </fixed-header>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import cartSvg from '../svg/cart.svg'
import gradLogoSvg from '../svg/grad-logo.svg'
import helpSvg from '../svg/help.svg'
import GoogleAnalytics from '@Shared/lib/google-analytics'
import ResponsiveBreakpointsMixin from '@Shared/mixins/responsive-breakpoints'

export default {
  name: 'SiteHeader',
  components: {
    FixedHeader
  },
  mixins: [ResponsiveBreakpointsMixin],
  data () {
    return {
      cartIndexUrl: window.pageData.siteHeader.cartIndexUrl,
      catalogListUrl: window.pageData.siteHeader.catalogListUrl,
      contactUsUrl: window.pageData.siteHeader.contactUsUrl,
      customerPin: window.pageData.siteHeader.customerPin,
      emailUsUrl: window.pageData.siteHeader.emailUsUrl,
      faqUrl: window.pageData.siteHeader.faqUrl,
      fixedHeaderThreshhold: 96,
      homeIndexUrl: window.pageData.siteHeader.homeIndexUrl,
      homeSearchUrl: window.pageData.siteHeader.homeSearchUrl,
      languageLinks: window.pageData.siteHeader.languageLinks,
      liveChatLink: window.pageData.siteHeader.liveChatLink,
      numItemsInCart: window.pageData.siteHeader.numItemsInCart,
      occasionStatusIsPreEvent: window.pageData.siteHeader.occasionStatusIsPreEvent,
      preOrderUrl: window.pageData.siteHeader.preOrderUrl,
      preregistrationUrl: window.pageData.siteHeader.preregistartionUrl,
      proofsIndexUrl: window.pageData.siteHeader.proofsIndexUrl,
      resourceStrings: window.pageData.siteHeader.resourceStrings,
      selectedLanguage: window.pageData.siteHeader.selectedLanguage,
      showCartBadge: false,
      showBalfourOffers: false,
      showCatalogListNavItem: window.pageData.siteHeader.showCatalogListNavItem,
      siteRoot: window.pageData.siteRoot,
      specialOffersUrl: window.pageData.siteHeader.specialOffersUrl,
      trackUrl: window.pageData.siteHeader.trackUrl,
      cartSvg,
      gradLogoSvg,
      helpSvg
    }
  },
  computed: {
    proofsLinkNavItemClasses () {
      return {
        'header__navigation-item': true,
        'header__navigation-item--vmp': true,
        'hidden-xs': this.showCatalogListNavItem === true
      }
    },
    packageListNavItemClasses () {
      return {
        'header__navigation-item': true,
        'header__navigation-item--vmp': true,
        'visible-xs': this.showCatalogListNavItem === true,
        hidden: this.showCatalogListNavItem === false
      }
    }
  },
  created () {
    document.addEventListener('package.addedToCartSuccess', () => {
      this.showCartBadge = true

      setTimeout(() => {
        this.showCartBadge = false
      }, 5000)
    })

    document.addEventListener('cart.numItemsChanged', ev => {
      this.numItemsInCart = ev.detail.numItems
    })
  },
  methods: {
    openChatWindow () {
      this.$http
        .get(`${this.siteRoot}Ajax/IsChatOnline`)
        .then(resp => {
          if (!resp.data) {
            document.dispatchEvent(
              new CustomEvent('liveChat.showOfflineModal')
            )
          } else {
            var wleft = (screen.width - 580 - 32) / 2
            var wtop = (screen.height - 610 - 96) / 2
            window.open(
              this.liveChatLink,
              'shoretelchat',
              'left=' +
                wleft +
                ',top=' +
                wtop +
                ',width=580,height=610,toolbar=no,location=no,directories=no,status=yes,menubar=no,scrollbars=no,copyhistory=no,resizable=yes'
            )
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    handleCartLinkClick () {
      GoogleAnalytics.trackEvent('Header', 'click', 'Shopping Cart Icon')
    },
    handleLanguageNavClick (languageCode) {
      GoogleAnalytics.trackEvent(
        'Preferences',
        'Changed Language',
        languageCode
      )
    },
    handleSpecialOffersLinkClick () {
      GoogleAnalytics.trackEvent('Special Offers - Top Nav', 'click', 'Special Offers')
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  background-color: #fff;

  @media screen and (min-width: $screen-sm-min) {
    &--fixed {
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 1000;
      -webkit-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transition: all 0.2s ease;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-header/components/SiteHeader.vue